import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { get } from '../../services/apiController';
import { toast } from 'react-toastify';
import { FloatingLabel, Form } from 'react-bootstrap';
import { setVMBranches } from '../../store/reducers/common_reducer';
import { getStoredData, get_auth_key } from '../../util';
import { setAppFactory } from '../../store/reducers/account_reducer';

const FactoryDropdown = (props) => {
  const branches = useSelector((state) => state.common.vmBranches);
  const storedData = useMemo(() => JSON.parse(getStoredData(get_auth_key())), []);
  const [selectedLocation, setSelectedLocation] = useState(localStorage.getItem('factoryId') ?? '');
  const dispatch = useDispatch();

  const locationDropdown = useMemo(() => {
    if (['admin', 'super-admin', 'machine-admin'].includes(storedData?.role)) {
      return branches.filter((item) => item?.type === 'factory' && item?.isActive === true);
    } else if (storedData?.role === 'vehicle-manager' || storedData?.role === 'machine-manager') {
      return branches.filter((item) => item?.type === 'factory' && item?.isActive === true && storedData.locationId.includes(item?.id));
    }
    return branches;
  }, [branches, storedData]);

  function getLocations() {
    try {
      get(`/branches/`).then((response) => {
        dispatch(setVMBranches(response.data.rows));
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  }

  function onChangeLocation(e) {
    const selectedValue = e.target.value;
    localStorage.setItem('factoryId', selectedValue);
    setSelectedLocation(selectedValue);
    dispatch(setAppFactory(selectedValue));
    props.onFactoryChange();
  }

  useEffect(() => {
    if (branches.length === 0) {
      getLocations();
    }
  }, [branches]);

  return props.withFloatingLable ? (
    <FloatingLabel controlId="floatingInput" label="Select Factory">
      <Form.Select value={selectedLocation} onChange={onChangeLocation} className="all-select-custom" aria-label="Default select example">
        <option value="">Select Factory</option>
        {locationDropdown.map((item) => (
          <option key={item?.id} value={item?.id}>
            {item?.name}
          </option>
        ))}
      </Form.Select>
    </FloatingLabel>
  ) : (
    <div className="form-group col-md-2 col-lg-2">
      <label className={props.labelHide ? 'd-none' : undefined} htmlFor="exampleInputEmail1">
        Factory
      </label>
      <Form.Select value={selectedLocation} onChange={onChangeLocation} className="all-select-custom" aria-label="Default select example">
        <option value="">Select Factory</option>
        {locationDropdown.map((item) => (
          <option key={item?.id} value={item?.id}>
            {item?.name}
          </option>
        ))}
      </Form.Select>
    </div>
  );
};

export default React.memo(FactoryDropdown);
